module.exports = __webpack_public_path__ + "img/hk.e9ad91a3.png";